import { saveQueueService } from './save-queue.service';

/**
 */
class AuthStorageService {
  /**
   */
  async syncToken(): Promise<void> {
    try {
      const token = this.getTokenFromLocalStorage();

      if (!token) {
        console.warn('⚠️ No token found. The Service Worker cannot handle authenticated requests.');
        return;
      }

      await saveQueueService.saveToken(token);
      console.log('🔑 Token synced to IndexedDB.');
    } catch (error) {
      console.error('Token sync failed:', error);
    }
  }

  /**
   */
  private getTokenFromLocalStorage(): string | null {
    // Usually stored in localStorage under the 'auth-storage' or 'token' key.
    const authData = localStorage.getItem('auth-storage');

    if (authData) {
      try {
        const parsed = JSON.parse(authData);
        return parsed.state?.token || null;
      } catch (e) {
        console.error('Auth storage parsing failed:', e);
      }
    }

    return localStorage.getItem('token');
  }

  /**
   */
  async clearToken(): Promise<void> {
    try {
      await saveQueueService.removeToken();
      console.log('🔑 Token removed from IndexedDB.');
    } catch (error) {
      console.error('Token removal failed:', error);
    }
  }

  /**
   */
  async onLogin(): Promise<void> {
    await this.syncToken();
  }

  /**
   */
  async onLogout(): Promise<void> {
    await this.clearToken();
  }
}

export const authStorageService = new AuthStorageService();
